import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';
import type { OmitStylesComponentProps } from '../../types';

const avatarFallbackVariants = cva('rocco-avatar-fallback', {
    variants: {
        variant: {
            default:
                'flex size-full items-center justify-center rounded-full bg-black font-medium text-white',
        },
        size: {
            default: 'text-lg',
            sm: 'text-sm',
            md: 'text-base',
            xs: 'text-xs',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

export const AvatarFallback = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Fallback>,
    OmitStylesComponentProps<typeof AvatarPrimitive.Fallback> &
        VariantProps<typeof avatarFallbackVariants>
>(({ variant, size, className, ...props }, ref) => (
    <AvatarPrimitive.Fallback
        ref={ref}
        className={cn(avatarFallbackVariants({ variant, size, className }))}
        {...props}
        delayMs={props.delayMs ?? 300}
    />
));

AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;
